import { NavigationFinance } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { InvoicingPlan } from "@src/components/modules/invoicing-plan/List";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Invoicing plan`} navigation={<NavigationFinance />}>
    <InvoicingPlan />
  </MainLayout>
);

export const Route = createFileRoute("/invoices/invoicing-plan/")({
  component: Page,
});
